import { Box, Flex, type GridColDef, Label, Text } from '@shared/components';
import { dayjs, formatDateTime } from '@shared/utils';
import { UserTypeAvatar } from '@user-management/components';
import {
  RoleUserDeletionButton,
  USER_COLOR_STATUS,
  USER_STATUS_TEXT,
  UserStatus,
} from '@user-management/role-user-management';

export interface RoleUserListRowItem {
  userId: string;
  profile: {
    firstName: string;
    lastName: string;
    email: string;
    profilePic: string;
  };
  lastLoginAt: string;
  invitationExpireAt?: Date | string | null;
  status: UserStatus;
}

export const baseColumns: GridColDef<RoleUserListRowItem>[] = [
  {
    field: 'profile',
    headerName: 'Name',
    flex: 1,
    renderCell: (params) => {
      const { firstName, lastName, email, profilePic } = params.row.profile;
      return (
        <Flex sx={{ gap: (theme) => theme.spacing(3) }}>
          <UserTypeAvatar fullName={`${firstName} ${lastName}`} email={email} src={profilePic} />
          <Box>
            <Text variant='body1Semibold'>
              {firstName} {lastName}
            </Text>
            <Text variant='body2' sx={{ color: (theme) => theme.palette.text.secondary }}>
              {email}
            </Text>
          </Box>
        </Flex>
      );
    },
  },
  {
    field: 'lastLoginAt',
    headerName: 'Last Login',
    type: 'string',
    width: 160,
    valueFormatter: (params) => {
      return `${params.value ? formatDateTime(params.value) : '-'}`;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 160,
    renderCell: (params) => {
      if (!params.row.status) return null;

      let status = params.row.status;
      if (
        status === UserStatus.INVITATION_PENDING &&
        dayjs(params.row.invitationExpireAt).isBefore(dayjs())
      ) {
        status = UserStatus.INVITATION_EXPIRED;
      }
      return (
        <Label
          sx={{ px: (theme) => theme.spacing(3) }}
          color={USER_COLOR_STATUS[status]}
          variant='outlined'
        >
          {USER_STATUS_TEXT[status]}
        </Label>
      );
    },
  },
];

export const deleteUserColumn: GridColDef<RoleUserListRowItem> = {
  field: 'deleteIcon',
  headerName: '',
  width: 80,
  renderCell: (params) => {
    const { userId } = params.row;
    return <RoleUserDeletionButton userId={userId} />;
  },
  sortable: false,
};
